import { ofType } from "redux-observable";
import { guard } from "../../guards/guard";
import { TypeActionNursery } from "../actionNursery";
import { checkHasEnoughResourcesForCultivation } from "../checks/checkHasEnoughResourcesForCultivation";
import { pathCultivationNotEnoughResources } from "../paths/pathCultivationNotEnoughResources";
import { pathNurseryCultivate } from "../paths/pathNurseryCultivate";
export var epicCultivateRecipe = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionNursery.Cultivate), guard(state$, deps, pathNurseryCultivate)([
        checkHasEnoughResourcesForCultivation(pathCultivationNotEnoughResources),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/epics/epicCultivateRecipe.ts
// module id = 2027
// module chunks = 3